<template>
    <div class="container data">
        <h3>{{ $translate('company_details_h3', 'Kontaktuppgifter') }}</h3>
        <ul class="custom-list">
            <li
                v-for="(day, index) in contact"
                :key="index"
            >
                <span>{{ day.text }}</span>
                <span v-if="day.value">{{ day.value }}</span>
                <span v-else>-</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true,
        },
        model: {
            type: Object,
            required: true,
        }
    },
    computed: {
        contact() {
            return [
                {
                    text: this.$translate('company_details_name', 'Företagsnamn'),
                    value: this.model.company.name
                },
                {
                    text: this.$translate('company_details_org_nr', 'Org.nummer'),
                    value: this.model.company.registrationNumber
                },
                {
                    text: this.$translate('company_details_address', 'Adress'),
                    value: this.model.company.addres
                },
                {
                    text: this.$translate('company_details_postal_code', 'Postnummer'),
                    value: this.model.company.postalNumber
                },
                {
                    text: this.$translate('company_details_county', 'Ort'),
                    value: this.model.company.county
                },
                {
                    text: this.$translate('company_details_phone', 'Telefon'),
                    value: this.model.company.phone
                },
                {
                    text: this.$translate('company_details_email', 'E-post'),
                    value: this.model.company.email
                }
            ];
        }
    }
};
</script>
